import App from "./App"
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import store from "redux/store"
import { QueryClient, QueryClientProvider } from "react-query"
import moment from "moment"
import "moment/locale/id"

// Set global locale for moment to Indonesian
moment.locale("id")
const queryClient = new QueryClient()

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>,
  document.getElementById("root"),
)
